import { css, html, LitElement } from "lit";
import { property } from "lit/decorators/property.js";
import { TUrl } from "../../api-sdk/types";

const DEFAULT_BEAM_LOGO = "https://cdn01.beamimpact.com/chains/img/beam-logo.png";

export class BeamPartnerLogos extends LitElement {
  @property({ type: String }) partnerLogoUrl: TUrl = "";
  @property() beamLogoUrl: TUrl = DEFAULT_BEAM_LOGO;
  @property() partnerName = ""; // for alt-text

  render() {
    const { partnerLogoUrl, beamLogoUrl, partnerName } = this;

    return html`
      <span class="partner-logo">
        <img src="${partnerLogoUrl}" data-speedsize-ignore="true" part="partner-logo" alt="${partnerName} Logo" />
      </span>
      <span class="logo-separator" part="logo-separator"></span>
      <a class="beam-logo" href="https://beamimpact.com" target="_blank" rel="external">
        <img src="${beamLogoUrl}" data-speedsize-ignore="true" part="beam-logo" alt="Beam Impact Logo" />
      </a>
    `;
  }

  static styles = css`
    :host {
      height: 50px;
      display: flex;
      align-items: center;
    }

    .partner-logo,
    .beam-logo {
      position: relative;
    }

    .partner-logo img {
      height: var(--beam-PartnerLogos-partnerLogo-height, 32px);
      position: relative;
      bottom: var(--beam-PartnerLogos-partnerLogo-bottom, 0px);
    }

    .logo-separator {
      border-left: 1px solid var(--beam-PartnerLogos-divider-color, lightgray);
      margin-right: var(--beam-PartnerLogos-divider-marginRight, 20px);
      margin-left: var(--beam-PartnerLogos-divider-marginLeft, 20px);
      height: var(--beam-PartnerLogos-divider-height, 40px);
      display: inline-block;
    }

    .beam-logo img {
      height: var(--beam-PartnerLogos-beamLogo-height, 32px);
      position: relative;
      bottom: var(--beam-PartnerLogos-beamLogo-bottom, 5px);
    }
  `;
}

export const partnerLogosConfigDefaults = {
  "--beam-PartnerLogos-partnerLogo-height": "32px",
  "--beam-PartnerLogos-partnerLogo-bottom": "0px",
  "--beam-PartnerLogos-divider-color": "lightgray",
  "--beam-PartnerLogos-divider-marginRight": "20px",
  "--beam-PartnerLogos-divider-marginLeft": "20px",
  "--beam-PartnerLogos-divider-height": "40px",
  "--beam-PartnerLogos-beamLogo-height": "32px",
  "--beam-PartnerLogos-beamLogo-bottom": "5px",
} as const;

customElements.get("beam-partner-logos") || customElements.define("beam-partner-logos", BeamPartnerLogos);

declare global {
  interface HTMLElementTagNameMap {
    "beam-partner-logos": BeamPartnerLogos;
  }
}
